import SCHEDULE from '@webapp-next/modules/schedule/events';
import PEOPLE from '@webapp-next/modules/people/events';
import ME from '@webapp-next/modules/me/events';
import PROFILE from '@webapp-next/modules/profile/events';
import ENTERPRISE from '@webapp-next/modules/enterprise/events';
import GLOBAL_SETTINGS from '@webapp-next/modules/global-settings/events';
import TRIAL_ONBOARDING from '@webapp-next/modules/trial-onboarding/events';
import NEWSFEED from '@webapp-next/modules/newsfeed/events';
import LOCATION from '@webapp-next/modules/locations/events';
import INTEGRATIONS from '@webapp-next/modules/integrations/events';
import INTEGRATIONS_CONNECT from '@webapp-next/modules/integrations-connect/events';
import SCHEDULE_NEXT from '@webapp-next/modules/schedule/events';
import TASKS from '@webapp-next/modules/tasks/events';
import TIMESHEET from '@webapp-next/modules/timesheet/events';
import LOCATIONS_SETUP from '@webapp-next/modules/locations-setup/events';
import LEAVE from '@webapp-next/modules/leave/events';
import HIRE from '@webapp-next/modules/hire/events';
import WORKERS_ON_DEMAND from '@webapp-next/modules/schedule-workers/events';
import { APP_PAY_EVENTS as PAY } from '@webapp-next/modules/people/modules/pay-rates/definitions';
import HOME_DASHBOARD from '@apps-home-dashboard/events';
import ONCE from '@apps-once/events';
import PAYROLL from '@apps-payroll/events';
import REPORTS from '@webapp-next/modules/reports/events';
import LOCATIONS_APP from '@apps-locations/events';
import LEGACY_REPORTS from '@apps-legacy-reports/events';
import AWARDS from '@/modules/awards/events';
import AVAILABILITY from '@/modules/availability/events';
import BILLING from '@/modules/billing-tenant/events';
import MESSAGING from '@/modules/chat/events';

const VueEvents = {
  SCHEDULE,
  PEOPLE,
  ME,
  PROFILE,
  ENTERPRISE,
  GLOBAL_SETTINGS,
  TRIAL_ONBOARDING,
  NEWSFEED,
  LOCATION,
  INTEGRATIONS,
  INTEGRATIONS_CONNECT,
  SCHEDULE_NEXT,
  TASKS,
  LOCATIONS_SETUP,
  LEAVE,
  HIRE,
  TIMESHEET,
  WORKERS_ON_DEMAND,
  HOME_DASHBOARD,
  PAY,
  ONCE,
  PAYROLL,
  REPORTS,
  LOCATIONS_APP,
  LEGACY_REPORTS,
  AWARDS,
  AVAILABILITY,
  BILLING,
  MESSAGING,
};

export default VueEvents;
